$(window).load(function() {

  // Animate loader off screen

  function showloader(){
    $("#bodymovin").addClass("hide");
    $("#type-0").addClass("page-loaded");
    $("#type-0 > header").addClass("header_animation");
    $("#type-0 > .section-0").addClass("zoom_animation");
  }

  function showloadernormal(){
    $("#type-1").addClass("page-loaded");
    $("#type-1 > header").addClass("header_animation");
    $("#type-1 > .section-0").addClass("zoom_animation");
  }

 window.setTimeout( showloader, 3200 );
 window.setTimeout( showloadernormal, 0 );

});

/*------------------*/

$(document).ready(function() {
  // Smooth scroll
  $("html").easeScroll();

  // Timeline
  $('.timeline_info_container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.timeline_img_container, .years_list'
  });

  $('.timeline_img_container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.timeline_info_container, .years_list',
  });

  $('.years_list').slick({
    slidesToShow: 10,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    asNavFor: '.timeline_info_container, .timeline_img_container',
  });

  // Gallery

  $('.gallery_container > ul').slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    focusOnSelect:true,
    dotsClass: 'custom_paging',
    customPaging: function (slider, i) {
        //FYI just have a look at the object to find available information
        //press f12 to access the console in most browsers
        //you could also debug or look in the source
        console.log(slider);
        return  (i + 1) + '/' + slider.slideCount;
    }
  });

  // Page transition
  $('.transition').on('click', function(e) {
    $('.page-transition').toggleClass("show-me");
  });

  $('.menu-item > a').on('click', function(e) {
    $('.page-transition').toggleClass("show-me");
  });

  // Button Nav
  $(".button-nav").click(function(){
    $(this).toggleClass("open");
    //console.log(this);
    $(".container-nav-mobile").toggleClass("open");
    $("header").toggleClass("open");
  });

  $(".container-nav-mobile .mobile ul li a").click(function(){
    $(".button-nav").removeClass("open");
    $(".container-nav-mobile").removeClass("open");
  });

});


  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('header').outerHeight();

  $(window).scroll(function(event){
    didScroll = true;
    if ($(window).scrollTop() >= 100) {
      $('header').addClass('scrolled');
     }
     else {
      $('header').removeClass('scrolled');
     }
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 100);

  function hasScrolled() {
    var st = $(this).scrollTop();
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
      // Scroll Down
      $('header').removeClass('down').addClass('top');
      $('header.mobile').removeClass('down').addClass('top');
    } else {
      // Scroll Up
      if(st + $(window).height() < $(document).height()) {
        $('header').removeClass('top').addClass('down');
        $('header.mobile').removeClass('top').addClass('down');
      }
    }
    lastScrollTop = st;
  }

/*------------------*/

// Smooth scroll animation on <a href="#"> click
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});

/*------------------*/

// Import font
WebFontConfig = {
  google: { families: [ 'Playfair+Display:400,400i' ] }
};
(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();